import React, { FC } from 'react'
import {
  Filter,
  List,
  Datagrid,
  TextField,
  TextInput,
  ListProps,
} from 'react-admin'

const AttachmentFilter = (props: any) => {
  return (
    <Filter {...props}>
      <TextInput label="Search" source="q" alwaysOn />
    </Filter>
  )
}

export const ListAttachments: FC<ListProps> = (props: any) => {
  const { staticContext, ...rest } = props
  return (
    <List
      // filters={<AttachmentFilter />}
      {...rest}
      data-testid="list"
    >
      <Datagrid rowClick={'edit'}>
        <TextField label="#" source="id" />
        <TextField label="Título" source="title" />
        <TextField label="Tipo" source="type" />
        <TextField label="Slug" source="slug" />
        <TextField label="Path" source="path" />
        <TextField label="Descrição" source="description" />
      </Datagrid>
    </List>
  )
}
